import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import {
  filterElement,
  filtersConfig,
  MAIN_TAXIPARK_OPTIONS_QUERY_KEY,
} from '~/features/BookingCars/ListBookingCars/config'
import { Taxipark } from '~/shared/api'
import { Option } from '~/shared/config/constants'
import { Button } from '~/shared/ui/Buttons'
import { DrawerComponent, useDrawer } from '~/shared/ui/Drawer'
import { IonCheckbox as Checkbox } from '~/shared/ui/form/Checkbox'
import { useFiltersQueryParams } from '~/shared/ui/ScrollableList'
import { Title, SubTitle, Wrapper, DrawerWrapper, DrawerTitle } from './styled'

const { brandModel, price, location, region, taxipark } = filterElement

export function TaxiparkFilter() {
  const [isShow, openDrawer, closeDrawer] = useDrawer()
  const [filtersQuery, setFiltersQuery] = useFiltersQueryParams(filtersConfig)

  const regionCodeFilter = filtersQuery[region.field]?.id
  const taxiparkIdFilter = filtersQuery[taxipark.field]?.id
  const taxiparkLabelFilter = filtersQuery[taxipark.field]?.label

  const { isFetching, isLoading, isPreviousData, data } = useQuery<Option[]>(
    [MAIN_TAXIPARK_OPTIONS_QUERY_KEY, regionCodeFilter],
    () => Taxipark.fetchOptions(regionCodeFilter),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false,
    },
  )

  const handleOnChange = (option: Option) => {
    closeDrawer()
    setFiltersQuery(
      {
        [taxipark.field]: taxiparkIdFilter === option.id ? undefined : option,
        [price.option.fromField]: undefined,
        [price.option.toField]: undefined,
        [brandModel.first.field]: undefined,
        [brandModel.second.field]: undefined,
        [location.field]: undefined,
      },
      'replaceIn',
    )
  }

  const isPending = isLoading || (isFetching && isPreviousData)

  const options = useMemo(() => data ?? [], [data])

  return (
    <div>
      <Wrapper>
        <SubTitle>Таксопарк</SubTitle>
        <Title data-testid='selected-taxipark'>
          {taxiparkLabelFilter || 'Таксопарк не выбран'}
        </Title>

        <Button
          loading={isPending}
          variant='lightSteelBlueBorder'
          onClick={openDrawer}
          fullWidth
          contentProps={{
            style: {
              fontSize: '14px',
              padding: '10px',
              height: '34px',
            },
          }}
          style={{ marginTop: '12px' }}
        >
          Изменить
        </Button>
      </Wrapper>

      <DrawerComponent isShow={isShow} onCancel={closeDrawer}>
        <DrawerWrapper>
          <DrawerTitle>Выбор Таксопарка</DrawerTitle>

          {!options.length && <div>Ошибка получения таксопарков</div>}

          {options.map((option) => (
            <Checkbox
              onClick={() => handleOnChange(option)}
              key={option.id}
              labelPlacement='end'
              justify='start'
              checked={option?.id === taxiparkIdFilter}
            >
              {option.label}
            </Checkbox>
          ))}
        </DrawerWrapper>
      </DrawerComponent>
    </div>
  )
}
